<script>
  import { onMount, onDestroy } from "svelte";
  import Templates from "./DesignTabs/Templates.svelte";
  import Scratch from "./DesignTabs/Scratch.svelte";
  import Builder from "../EmailBuilder/Builder.svelte";
  import { ignore, screenshot } from "../Common/tools";
  import { AB_CONTENT, DEFAULT_HTML_EMAIL_CONTENT, DEFAULT_TEXT_EMAIL_CONTENT, DEFAULT_UNSUBSCRIBE_BLOCK } from "./static";
  import {External, M} from "../external";

  export let data,
    onChange = ignore,
    features = {};

  let tab = "templates",
    builderMounted = false,
    isNewTemplateSelected = false,
    meta = {},
    instance,
    options = {
      features: features
    },
    split = "a";

  export function getSelectedSplit() {
    return split;
  }

  export function hasChange() {
    return instance ? instance.hasChange() || isNewTemplateSelected : false;
  }

  export async function verify() {
    return instance ? await instance.verify() : true;
  }

  export function saveAsTemplate(name) {
    if (!instance || name === "") {
      return;
    }

    let builderData = instance.get();
    builderData.name = External.Tools.generateUniqueId();
    builderData.subject = name;

    External.Tools.makeWebsiteRequest({
      action: "saveEmailTemplate",
      method: "post",
      data: {
        data: JSON.stringify(builderData)
      },
      onOk: function () {
        let width = builderData.content.style.width;
        screenshot({
          emailName: builderData.name,
          dimensions: width
        });
        External.Tools.showAutohideMessage(5, M.TEMPLATE_SAVED);
      }
    });
  }

  let onChangeTab = function (t) {
    tab = t;
  };

  let onTemplateSelected = function (id, type) {
    External.Tools.makeWebsiteRequest({
      action: "getEmailTemplate",
      data: {
        name: id,
        is_template: type !== "user"
      },
      onOk: function (response) {
        if (response.data == null) {
          return;
        }
        mountBuilder(response.data);
      }
    });
  };

  let mountBuilder = function (templateData) {
    let template;
    builderMounted = true;
    isNewTemplateSelected = true;
    if (typeof templateData === "string") {
      if (templateData === "text") {
        options = {
          textEditor: true,
          features: features
        };
        template = External.$.extend(true, {}, DEFAULT_TEXT_EMAIL_CONTENT);
      } else if (templateData === "html") {
        options = {
          html: true,
          features: features
        };

        template = {
          isCustom: true,
          content: DEFAULT_HTML_EMAIL_CONTENT
        };
      } else {
        template = {
          content: [External.$.extend(true, {}, DEFAULT_UNSUBSCRIBE_BLOCK)]
        };
      }
    } else {
      template = templateData.template.content;
    }

    if (data.type !== AB_CONTENT) {
      data = Object.assign({}, data, { content: template });
      return;
    }

    options.isContentSplitTest = true;
    data = Object.assign({}, data, { [split === "a" ? "content" : "contentB"]: template });
    onChange();
  };

  let onChangeSplit = (newSplit) => {
    let content = data[newSplit === "a" ? "content" : "contentB"];

    if (content) {
      if (content.isCustom) {
        options = {
          html: true,
          features: features
        };
      }
      builderMounted = true;
    } else {
      builderMounted = false;
    }

    split = newSplit;
  };

  let saveTemplateContent = () => {
    if (!instance) return;
    let builderData = instance.get();

    let content = options.html ? { isCustom: true, content: builderData.content } : builderData.content;

    if (data.type !== AB_CONTENT) {
      data.content = content;
    } else {
      data[split === "a" ? "content" : "contentB"] = content;
    }
  };

  let switchSplit = function (t) {
    External.Tools.prompt(
      M.SAVE_CHANGES,
      M.SAVE_TEMPLATE_CHANGES,
      function () {
        saveTemplateContent();
        onChangeSplit(t);
      },
      function () {
        onChangeSplit(t);
      },
      M.SAVE,
      M.DISCARD
    );
  };

  let onBuilderChange = () => {
    onChange();
  };

  onMount(function () {
    if (data.content) {
      if (data.content.isCustom) {
        options.html = true;
      }
      if (data.type === AB_CONTENT) {
        options.isContentSplitTest = true;
      }
      builderMounted = true;
    } else {
      let template = External.WebPlatform.getUrlQueryParameter(window.location.href, "template");
      let type = External.WebPlatform.getUrlQueryParameter(window.location.href, "type");

      if (!!template) {
        External.Tools.makeWebsiteRequest({
          action: "getEmailTemplate",
          data: {
            name: template,
            is_template: type === "predefined"
          },
          onOk: function (response) {
            if (response.data == null) {
              return;
            }
            data.content = response.data.template.content;
            builderMounted = true;
          }
        });
      }
    }
  });

  onDestroy(function () {
    saveTemplateContent();
  });

  $: if ((data.type !== AB_CONTENT && data.content == null) || (data.type === AB_CONTENT && data[split === "a" ? "content" : "contentB"] == null)) {
    builderMounted = false;
    options = {
      features: features
    };
  }
</script>

{#if data.type === AB_CONTENT}
  <ul class="upper-navigation upper-navigation-full ab-email-navigation">
    <li>
      <a on:click|preventDefault={() => switchSplit("a")} class:active={split === "a"}>{M.DESIGN_A}</a>
    </li>
    <li>
      <a on:click|preventDefault={() => switchSplit("b")} class:active={split === "b"}>{M.DESIGN_B}</a>
    </li>
  </ul>
{/if}
{#if !builderMounted}
  <div class="flex-1 overflow account-settings store-products">
    <div class="col20 f-left">
      <div class="top-background-wrapper wide-top-background">
        <h1 class="members-title col20 f-left mb-0 col20 roboto t-center" style="font-size: 32px; color: #fff;">
          {M.EMAIL_DESIGN}
        </h1>
      </div>

      <div class="content-wrapper horizontal-flex-table" style="margin-top: 100px;" data-role="table-content">
        <div class="sections-wrapper members-wrapper horizontal-flex-table">
          <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
            <ul class="upper-navigation upper-navigation-full mt-15">
              <li>
                <a class:active={tab === "templates"} on:click={() => onChangeTab("templates")}>{M.TEMPLATES_LIST}</a>
              </li>
              <li><a class:active={tab === "user"} on:click={() => onChangeTab("user")}>{M.MY_TEMPLATES}</a></li>
              <li><a class:active={tab === "scratch"} on:click={() => onChangeTab("scratch")}>{M.FROM_SCRATCH}</a></li>
            </ul>

            {#if tab === "templates"}
              <Templates tab={tab} onTemplateSelected={onTemplateSelected} />
            {:else if tab === "user"}
              <Templates tab={tab} onTemplateSelected={onTemplateSelected} />
            {:else}
              <Scratch onChoice={mountBuilder} />
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
{:else if data.type !== AB_CONTENT}
  <Builder addUnsubscribeBlockOnEmpty={true} editorData={data.content} meta={meta} bind:this={instance} options={options} onChange={onBuilderChange} />
{:else if split === "a"}
  <Builder addUnsubscribeBlockOnEmpty={true} editorData={data.content} meta={meta} bind:this={instance} options={options} onChange={onBuilderChange} />
{:else}
  <Builder addUnsubscribeBlockOnEmpty={true} editorData={data.contentB} meta={meta} bind:this={instance} options={options} onChange={onBuilderChange} />
{/if}
